import React, { useEffect } from 'react';

import { inject } from 'mobx-react';
import { ClassListViewDesktop } from 'modules/classManager/classListView/classListViewDesktop';
import { ClassListViewMobile } from 'modules/classManager/classListView/classListViewMobile';
import ClassService from 'modules/classManager/ClassService';
import PropTypes from 'prop-types';

import './ClassListView.scss';

const ClassListView = ({ isMobile }) => {
  useEffect(() => {
    const fetchClasses = async () => {
      await ClassService.fetchFormattedClasses();
    };

    fetchClasses();

    return () => ClassService.setStoreData({ search: '' });
  }, []);

  return isMobile ? <ClassListViewMobile /> : <ClassListViewDesktop />;
};

ClassListView.propTypes = {
  isMobile: PropTypes.bool
};

export default inject((store) => ({
  isMobile: store.UiStore.isMobile
}))(ClassListView);
